import { Alert } from '@beehive/components';
import * as React from 'react';
import ReactDOM from 'react-dom';

interface IshowAlertProps {
  type: string;
  message: string;
  description?: string;
  hideDelay?: number;
}

const showAlert = (props: IshowAlertProps) => {
  const { type = 'success', message, description, hideDelay = 3000 } = props;
  const alert = (
    <Alert
      message={message}
      description={description}
      type={type}
      showIcon
      position="fixed"
    />
  );
  const domDiv = document.createElement('div');
  document.body.appendChild(domDiv);
  ReactDOM.render(alert, domDiv);
  setTimeout(() => {
    document.body.removeChild(domDiv);
  }, hideDelay);
  return;
};

export default showAlert;
